module.exports = __webpack_public_path__ + "static/media/three-sitting-talk.6797191b.PNG";